import { render, staticRenderFns } from "./AddProductsType.vue?vue&type=template&id=2ea646c8&scoped=true"
import script from "./AddProductsType.vue?vue&type=script&lang=js"
export * from "./AddProductsType.vue?vue&type=script&lang=js"
import style0 from "./AddProductsType.vue?vue&type=style&index=0&id=2ea646c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea646c8",
  null
  
)

export default component.exports